import React, { useEffect, useState } from "react";
import { Row, Col, Button, Flex, App } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import CreatePurchaseReturnForm from "./components/CreatePurchaseReturnForm";
import PurchaseReturnTable from "./components/PurchaseReturnTable";
import {
  createPurchaseReturn,
  fetchPurchaseReturnNumber,
  fetchPurchaseReturnRecord,
} from "./purchaseReturnThunk";
import {
  resetPurchaseReturn,
  setInvoiceList,
  setIsTatmeen,
  updateOrderRow,
  setSelectedInvoice,
  setSupplier,
  setUpdatedService,
} from "./purchaseReturnSlice";
import Swal from "sweetalert2";
import { selectAuthInfo } from "../../../Auth/authSelectors";
import { getAccessType, pathSpliter } from "../../../../lib/functions";

const PurchaseReturnEntry = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { modal } = App.useApp();

  const authInfo = useSelector(selectAuthInfo);
  const { itemCart, supplierInfo, footerValues, voucherNumber, selectedPurchaseReturnAcc, payServiceCart, isTatmeen, parentSsccCode
  } = useSelector((s) => s.purchaseReturn);

  let [access_type, access_type_set] = useState("");
  const [updatedServices, setUpdatedServices] = useState([]);

  const pur_r_id = pathSpliter(location.pathname, 2)
    ? pathSpliter(location.pathname, 2)
    : null;

  const isTatmeenUAE =
    authInfo?.is_tatmeen_enabled === "yes" &&
    authInfo?.country === "United Arab Emirates" && (authInfo?.subscription == 'PharmaERP_Pro' || authInfo?.subscription == 'PharmaERP_Standard' || authInfo?.subscription == 'PharmaERP_Basic');

  useEffect(() => {
    const access = getAccessType("purchase_return");
    access_type_set(access);
  }, []);

  //reset on component unmounting
  useEffect(() => {
    return () => {
      dispatch(resetPurchaseReturn());
    };
  }, [dispatch]);

  useEffect(() => {
    if (!pur_r_id && !voucherNumber) {
      dispatch(resetPurchaseReturn());
      dispatch(fetchPurchaseReturnNumber());
    }
  }, [pur_r_id, dispatch]);


  useEffect(() => {
    if (pur_r_id) {
      dispatch(fetchPurchaseReturnRecord(pur_r_id));
    }
  }, [pur_r_id, dispatch]);

  useEffect(() => {
    dispatch(setUpdatedService(updatedServices));
  }, [updatedServices]);


  // src/pages/Purchase/Purchase Return/PurchaseReturnEntry.jsx

  // ============================================
  // 🚀 Comprehensive Tatmeen Validation (Updated)
  // ============================================
  // const validateTatmeen = () => {
  //   // Only validate if Tatmeen is enabled for UAE
  //   if (!isTatmeenUAE) return { valid: true };

  //   // ✅ If Tatmeen is NOT enabled, check if any SSCC codes are provided
  //   if (!isTatmeen) {
  //     const hasParentSSCC = parentSsccCode && parentSsccCode.trim() !== "";
  //     const hasChildSSCC = itemCart.some(
  //       item => item.child_sscc_code && item.child_sscc_code.trim() !== "" && Number(item.return_qty) > 0
  //     );

  //     if (hasParentSSCC || hasChildSSCC) {
  //       return {
  //         valid: false,
  //         message: "SSCC codes are provided but Tatmeen is not enabled.\n\nPlease enable Tatmeen to use SSCC codes, or clear the SSCC fields.",
  //       };
  //     }
  //     return { valid: true };
  //   }

  //   // ============================================
  //   // RULE 1: If Tatmeen is enabled, Parent SSCC is required
  //   // ============================================
  //   if (!parentSsccCode || parentSsccCode.trim() === "") {
  //     return {
  //       valid: false,
  //       message: "Tatmeen is enabled but Parent SSCC Code is missing.\n\nPlease enter the Parent SSCC Code for this return.",
  //     };
  //   }

  //   // ============================================
  //   // RULE 2: Items with return_qty > 0 must have Child SSCC
  //   // ============================================
  //   const itemsWithReturn = itemCart.filter(item => Number(item.return_qty) > 0);

  //   if (itemsWithReturn.length === 0) {
  //     return {
  //       valid: false,
  //       message: "No items with return quantity found.\n\nPlease add at least one item with return quantity > 0.",
  //     };
  //   }

  //   const itemsMissingChildSSCC = itemsWithReturn.filter(
  //     item => !item.child_sscc_code || item.child_sscc_code.trim() === ""
  //   );

  //   if (itemsMissingChildSSCC.length > 0) {
  //     const itemNames = itemsMissingChildSSCC
  //       .map((item, index) => `${index + 1}. ${item.product || `Item ID: ${item.item_id}`}`)
  //       .join('\n');

  //     return {
  //       valid: false,
  //       message: `Tatmeen is enabled but the following items with return quantity are missing Child SSCC Code:\n\n${itemNames}\n\nEach returned item must have a Child SSCC Code.`,
  //     };
  //   }

  //   // ============================================
  //   // RULE 3: Child SSCC validation with Parent
  //   // ============================================
  //   const childSSCCs = itemsWithReturn
  //     .map(item => item.child_sscc_code?.trim() || "")
  //     .filter(code => code !== "");

  //   if (childSSCCs.length === 0) {
  //     return {
  //       valid: false,
  //       message: "No Child SSCC Codes found for returned items.\n\nEach returned item must have a Child SSCC Code.",
  //     };
  //   }

  //   const distinctChildSSCCs = [...new Set(childSSCCs)];

  //   if (distinctChildSSCCs.length === 1) {
  //     // If all child SSCC are same, parent SSCC should also be the same
  //     const childSSCC = distinctChildSSCCs[0];
  //     if (parentSsccCode.trim() !== childSSCC) {
  //       return {
  //         valid: false,
  //         message: `All Child SSCC Codes are "${childSSCC}" but Parent SSCC Code is "${parentSsccCode}".\n\nParent SSCC must match the Child SSCC when all are the same.`,
  //       };
  //     }
  //   } else if (distinctChildSSCCs.length > 1) {
  //     // If multiple distinct child SSCC, parent should NOT match any
  //     if (distinctChildSSCCs.includes(parentSsccCode.trim())) {
  //       return {
  //         valid: false,
  //         message: `Multiple distinct Child SSCC Codes found (${distinctChildSSCCs.join(', ')}).\n\nParent SSCC Code "${parentSsccCode}" matches one of the Child SSCC Codes, but it should be a different/unique code to group them all.\n\nParent SSCC must be different from all Child SSCC Codes when there are multiple distinct child codes.`,
  //       };
  //     }
  //   }

  //   // ============================================
  //   // RULE 4: Serial validation ONLY for items with return_qty > 0
  //   // ============================================
  //   return validateSerialsForTatmeen(itemsWithReturn);
  // };

  const validateTatmeen = () => {
    // Only validate if Tatmeen is enabled for UAE
    if (!isTatmeenUAE) return { valid: true };

    // ✅ If Tatmeen is NOT enabled, check if any SSCC codes are provided
    if (!isTatmeen) {
      const hasParentSSCC = parentSsccCode && parentSsccCode.trim() !== "";
      const hasChildSSCC = itemCart.some(
        item => item.is_tatmeen_required &&
          item.child_sscc_code &&
          item.child_sscc_code.trim() !== "" &&
          Number(item.return_qty) > 0
      );

      if (hasParentSSCC || hasChildSSCC) {
        return {
          valid: false,
          message: "SSCC codes are provided but Tatmeen is not enabled.\n\nPlease enable Tatmeen to use SSCC codes, or clear the SSCC fields.",
        };
      }
      return { valid: true };
    }

    // ============================================
    // RULE 1: If Tatmeen is enabled, Parent SSCC is required
    // ============================================
    if (!parentSsccCode || parentSsccCode.trim() === "") {
      return {
        valid: false,
        message: "Tatmeen is enabled but Parent SSCC Code is missing.\n\nPlease enter the Parent SSCC Code for this return.",
      };
    }

    // ============================================
    // RULE 2: 🔥 ONLY items with is_tatmeen_required = true need Child SSCC
    // ============================================
    const itemsWithReturn = itemCart.filter(item => Number(item.return_qty) > 0);
    const tatmeenItems = itemsWithReturn.filter(item => item.is_tatmeen_required === true);

    // If no Tatmeen required items with return quantity, validation passes
    if (tatmeenItems.length === 0) {
      return { valid: true };
    }

    const itemsMissingChildSSCC = tatmeenItems.filter(
      item => !item.child_sscc_code || item.child_sscc_code.trim() === ""
    );

    if (itemsMissingChildSSCC.length > 0) {
      const itemNames = itemsMissingChildSSCC
        .map((item, index) => `${index + 1}. ${item.product || `Item ID: ${item.item_id}`}`)
        .join('\n');

      return {
        valid: false,
        message: `Tatmeen is enabled and the following items have Tatmeen required but are missing Child SSCC Code:\n\n${itemNames}\n\nEach Tatmeen required item must have a Child SSCC Code.`,
      };
    }

    // ============================================
    // RULE 3: Child SSCC validation with Parent (only for Tatmeen required items)
    // ============================================
    const childSSCCs = tatmeenItems
      .map(item => item.child_sscc_code?.trim() || "")
      .filter(code => code !== "");

    if (childSSCCs.length === 0) {
      return {
        valid: false,
        message: "No Child SSCC Codes found for Tatmeen required items.\n\nEach Tatmeen required item must have a Child SSCC Code.",
      };
    }

    const distinctChildSSCCs = [...new Set(childSSCCs)];

    if (distinctChildSSCCs.length === 1) {
      const childSSCC = distinctChildSSCCs[0];
      if (parentSsccCode.trim() !== childSSCC) {
        return {
          valid: false,
          message: `All Child SSCC Codes are "${childSSCC}" but Parent SSCC Code is "${parentSsccCode}".\n\nParent SSCC must match the Child SSCC when all are the same.`,
        };
      }
    } else if (distinctChildSSCCs.length > 1) {
      if (distinctChildSSCCs.includes(parentSsccCode.trim())) {
        return {
          valid: false,
          message: `Multiple distinct Child SSCC Codes found (${distinctChildSSCCs.join(', ')}).\n\nParent SSCC Code "${parentSsccCode}" matches one of the Child SSCC Codes, but it should be a different/unique code to group them all.\n\nParent SSCC must be different from all Child SSCC Codes when there are multiple distinct child codes.`,
        };
      }
    }

    // ============================================
    // RULE 4: Serial validation ONLY for Tatmeen required items with return_qty > 0
    // ============================================
    return validateSerialsForTatmeen(tatmeenItems);
  };

  // ============================================
  // 🚀 Serial Validation for Tatmeen (Updated - Only items with return_qty > 0)
  // ============================================
  // const validateSerialsForTatmeen = (itemsWithReturn) => {
  //   if (!isTatmeenUAE || !isTatmeen) return { valid: true };

  //   // Collect all serials for cross-item validation
  //   const allSerials = [];
  //   const serialToItemMap = {};

  //   for (const row of itemsWithReturn) {
  //     // ✅ Skip items with no return quantity
  //     if (Number(row.return_qty) <= 0) continue;

  //     const serialMode = row.serial_mode || "unit";
  //     const returnQty = Number(row.return_qty) || 0;
  //     const selectedSerials = row.selectedSerials || [];

  //     // ============================================
  //     // UNIT MODE: Selected serials must match return quantity
  //     // ============================================
  //     if (serialMode === "unit") {
  //       // ✅ Check if serial count matches return quantity
  //       if (selectedSerials.length !== returnQty) {
  //         return {
  //           valid: false,
  //           message: `"${row.product}" requires ${returnQty} serial number${returnQty > 1 ? 's' : ''} but ${selectedSerials.length} selected.\n\nPlease select exactly ${returnQty} serial number${returnQty > 1 ? 's' : ''} for this item.`,
  //         };
  //       }

  //       // Check for duplicates within the same item
  //       const duplicateWithinItem = selectedSerials.filter(
  //         (s, index) => selectedSerials.indexOf(s) !== index
  //       );

  //       if (duplicateWithinItem.length > 0) {
  //         return {
  //           valid: false,
  //           message: `"${row.product}" contains duplicate serial numbers within the same item: ${duplicateWithinItem.join(', ')}.\n\nPlease remove duplicate serial numbers.`,
  //         };
  //       }

  //       // Store serials for cross-item validation
  //       selectedSerials.forEach(serial => {
  //         if (serial && serial.trim()) {
  //           const trimmedSerial = serial.trim();
  //           allSerials.push(trimmedSerial);
  //           if (!serialToItemMap[trimmedSerial]) {
  //             serialToItemMap[trimmedSerial] = [];
  //           }
  //           serialToItemMap[trimmedSerial].push(row.product);
  //         }
  //       });
  //     }
  //     // ============================================
  //     // BATCH MODE: Only 1 serial is required for the batch
  //     // ============================================
  //     else if (serialMode === "batch") {
  //       // ✅ Check if exactly 1 serial is selected
  //       if (selectedSerials.length !== 1) {
  //         return {
  //           valid: false,
  //           message: `"${row.product}" (Batch Mode) requires exactly 1 serial number but ${selectedSerials.length} selected.\n\nPlease select exactly 1 serial number for this batch item.`,
  //         };
  //       }

  //       // Store serial for cross-item validation
  //       const serial = selectedSerials[0];
  //       if (serial && serial.trim()) {
  //         const trimmedSerial = serial.trim();
  //         allSerials.push(trimmedSerial);
  //         if (!serialToItemMap[trimmedSerial]) {
  //           serialToItemMap[trimmedSerial] = [];
  //         }
  //         serialToItemMap[trimmedSerial].push(row.product);
  //       }
  //     }
  //   }

  //   // ============================================
  //   // CROSS-ITEM SERIAL VALIDATION
  //   // Check if any serial appears in more than one item
  //   // ============================================
  //   const serialCount = {};
  //   allSerials.forEach(serial => {
  //     serialCount[serial] = (serialCount[serial] || 0) + 1;
  //   });

  //   const duplicateSerials = Object.keys(serialCount).filter(
  //     serial => serialCount[serial] > 1
  //   );

  //   if (duplicateSerials.length > 0) {
  //     const duplicateDetails = duplicateSerials.map(serial => {
  //       const items = serialToItemMap[serial] || [];
  //       const uniqueItems = [...new Set(items)];
  //       return `Serial "${serial}" appears in: ${uniqueItems.join(', ')}`;
  //     }).join('\n');

  //     return {
  //       valid: false,
  //       message: `Duplicate serial numbers found across different items:\n\n${duplicateDetails}\n\nEach serial number must be unique across all items in this return.`,
  //     };
  //   }

  //   return { valid: true };
  // };

  const validateSerialsForTatmeen = (tatmeenItems) => {
    if (!isTatmeenUAE || !isTatmeen) return { valid: true };

    // Collect all serials for cross-item validation
    const allSerials = [];
    const serialToItemMap = {};

    for (const row of tatmeenItems) {
      // ✅ Skip items with no return quantity
      if (Number(row.return_qty) <= 0) continue;

      const serialMode = row.serial_mode || "unit";
      const returnQty = Number(row.return_qty) || 0;
      const selectedSerials = row.selectedSerials || [];

      // UNIT MODE: Selected serials must match return quantity
      if (serialMode === "unit") {
        if (selectedSerials.length !== returnQty) {
          return {
            valid: false,
            message: `"${row.product}" requires ${returnQty} serial number${returnQty > 1 ? 's' : ''} but ${selectedSerials.length} selected.\n\nPlease select exactly ${returnQty} serial number${returnQty > 1 ? 's' : ''} for this item.`,
          };
        }

        // Check for duplicates within the same item
        const duplicateWithinItem = selectedSerials.filter(
          (s, index) => selectedSerials.indexOf(s) !== index
        );

        if (duplicateWithinItem.length > 0) {
          return {
            valid: false,
            message: `"${row.product}" contains duplicate serial numbers within the same item: ${duplicateWithinItem.join(', ')}.\n\nPlease remove duplicate serial numbers.`,
          };
        }

        // Store serials for cross-item validation
        selectedSerials.forEach(serial => {
          if (serial && serial.trim()) {
            const trimmedSerial = serial.trim();
            allSerials.push(trimmedSerial);
            if (!serialToItemMap[trimmedSerial]) {
              serialToItemMap[trimmedSerial] = [];
            }
            serialToItemMap[trimmedSerial].push(row.product);
          }
        });
      }
      // BATCH MODE: Only 1 serial is required for the batch
      else if (serialMode === "batch") {
        if (selectedSerials.length !== 1) {
          return {
            valid: false,
            message: `"${row.product}" (Batch Mode) requires exactly 1 serial number but ${selectedSerials.length} selected.\n\nPlease select exactly 1 serial number for this batch item.`,
          };
        }

        const serial = selectedSerials[0];
        if (serial && serial.trim()) {
          const trimmedSerial = serial.trim();
          allSerials.push(trimmedSerial);
          if (!serialToItemMap[trimmedSerial]) {
            serialToItemMap[trimmedSerial] = [];
          }
          serialToItemMap[trimmedSerial].push(row.product);
        }
      }
    }

    // CROSS-ITEM SERIAL VALIDATION
    const serialCount = {};
    allSerials.forEach(serial => {
      serialCount[serial] = (serialCount[serial] || 0) + 1;
    });

    const duplicateSerials = Object.keys(serialCount).filter(
      serial => serialCount[serial] > 1
    );

    if (duplicateSerials.length > 0) {
      const duplicateDetails = duplicateSerials.map(serial => {
        const items = serialToItemMap[serial] || [];
        const uniqueItems = [...new Set(items)];
        return `Serial "${serial}" appears in: ${uniqueItems.join(', ')}`;
      }).join('\n');

      return {
        valid: false,
        message: `Duplicate serial numbers found across different items:\n\n${duplicateDetails}\n\nEach serial number must be unique across all items in this return.`,
      };
    }

    return { valid: true };
  };

  const handleSave = () => {
    // ============================================
    // 🚀 Step 1: Run Tatmeen validation
    // ============================================
    const tatmeenValidation = validateTatmeen();
    if (!tatmeenValidation.valid) {
      Swal.fire({
        title: "Tatmeen Validation Error",
        html: tatmeenValidation.message.replace(/\n/g, '<br>'),
        icon: "warning",
        confirmButtonText: "OK"
      });
      return;
    }

    const grandTotal = parseFloat(footerValues?.grandTotal) || 0;
    const hasConversionRate = Number(footerValues?.conversion_rate) > 0;

    const maxAllowedCartTotal = hasConversionRate
      ? grandTotal + 0.1
      : grandTotal;

    if (!itemCart || itemCart.length === 0) {
      Swal.fire("Item cart is Empty!", "", "warning");
      return;
    }

    // check return_qty rule
    const hasValidReturnQty = itemCart.some(
      (item) => Number(item.return_qty || 0) > 0
    );
    if (!hasValidReturnQty) {
      Swal.fire(
        "At least one item must have return quantity greater than 0!",
        "",
        "warning"
      );
      return;
    }


    if (!supplierInfo || !supplierInfo.acc_id) {
      Swal.fire("Select supplier!", "", "warning");
      return;
    }
    if (!selectedPurchaseReturnAcc || !selectedPurchaseReturnAcc.acc_id) {
      Swal.fire("Select Purchase Return Account!", "", "warning");
      return;
    }
    if (Number(footerValues.grandTotal) <= 0) {
      Swal.fire("Grand Total Amount should not be 0!", "", "warning");
      return;
    }

    // validate paid amount vs payCart
    const payCart = footerValues.payCart || [];
    const payCartTotal = payCart.reduce(
      (sum, p) => sum + (parseFloat(p.tran_amount) || 0),
      0
    );

    const paid = Number(footerValues.paidAmount) || 0;
    const cartTotal = payCartTotal || 0;
    const grand = Number(footerValues.grandTotal || 0);
    const cart = Number(cartTotal || 0);
    // const payTotal = payCart.reduce(
    //   (sum, p) => sum + (parseFloat(p.tran_amount) || 0),
    //   0
    // );


    // if (Math.abs(grand - cart) > 0.01) {
    //   Swal.fire("Grand Total Amount should be same", "", "warning");
    //   return;
    // }

    if (cartTotal > maxAllowedCartTotal) {
      modal.warning({
        title: "Payment amount exceeds total!",
        content: `Cart Total (${cartTotal.toFixed(
          2
        )}) should not exceed Grand Total (${grandTotal.toFixed(2)})`,
      });
      return;
    }

    // ✅ Get isTatmeen from state

    // ✅ Validation 1: If Tatmeen is enabled, check for Child SSCC codes
    if (isTatmeenUAE && isTatmeen) {
      const itemsWithReturnButNoSSCC = itemCart.filter(
        item => Number(item.return_qty) > 0 &&
          item.is_tatmeen_required === true &&
          !item.child_sscc_code
      );

      if (itemsWithReturnButNoSSCC.length > 0) {
        const itemNames = itemsWithReturnButNoSSCC
          .map((item, index) => `${index + 1}. ${item.product || `Item ID: ${item.item_id}`}`)
          .join('\n');

        Swal.fire({
          title: "Child SSCC Code Required",
          html: `
          <div style="text-align: left;">
            <p>The following items require Child SSCC Code when Tatmeen is enabled:</p>
            <div style="background: #fff1f0; padding: 10px; margin: 10px 0; border-radius: 4px;">
              ${itemNames.replace(/\n/g, '<br>')}
            </div>
            <p style="color: #faad14;">
              <strong>Please fill in the Child SSCC Code for all items being returned.</strong>
            </p>
          </div>
        `,
          icon: "warning",
          confirmButtonText: "OK"
        });
        return;
      }
    }

    // ✅ Validation 2: If Child SSCC provided but Tatmeen not enabled
    if (isTatmeenUAE && !isTatmeen) {
      const hasChildSSCC = itemCart.some(
        item => item.child_sscc_code && item.child_sscc_code.trim() !== '' && Number(item.return_qty) > 0
      );

      if (hasChildSSCC) {
        Swal.fire({
          title: "Enable Tatmeen",
          html: `
          <div style="text-align: left;">
            <p>You have provided Child SSCC codes but Tatmeen is not enabled.</p>
            <p style="margin-top: 10px; color: #faad14;">
              <strong>Please enable Tatmeen to use Child SSCC codes.</strong>
            </p>
          </div>
        `,
          icon: "warning",
          confirmButtonText: "Enable Tatmeen",
          showCancelButton: true,
          cancelButtonText: "Clear SSCC Codes"
        }).then((result) => {
          if (result.isConfirmed) {
            dispatch(setIsTatmeen(true));
          } else {
            // Clear all child SSCC codes
            itemCart.forEach(item => {
              dispatch(updateOrderRow({
                rowKey: item.key,
                updates: { child_sscc_code: "" }
              }));
            });
          }
        });
        return;
      }
    }

    // ✅ Validation 3: Batch and Serial validation - ONLY if Tatmeen is enabled
    if (isTatmeenUAE && isTatmeen) {
      const invalidSerialRows = itemCart.filter(item => {
        // Skip items with no return qty
        if (Number(item.return_qty) === 0) {
          return false;
        }
        if (!item.is_tatmeen_required) return false;
        // Batch mode validation
        if (item.serial_mode === "batch") {
          const qty = Number(item.return_qty || 0);
          const availableQty = Number(item.available_qty || 0);

          // If returning a batch item, it must be the full batch
          return qty !== availableQty;
        }

        // Unit mode validation
        if (item.serial_mode === "unit") {
          // For unit mode, the selected serial count must match the return quantity
          return Number(item.return_qty || 0) !== (item.selectedSerials || []).length;
        }

        return false;
      });

      if (invalidSerialRows.length > 0) {
        const errorDetails = invalidSerialRows.map(item => {
          if (item.serial_mode === "batch") {
            return `• "${item.product}" - Batch mode requires full quantity return (${item.available_qty})`;
          } else {
            return `• "${item.product}" - ${Number(item.return_qty)} serial(s) required but ${(item.selectedSerials || []).length} selected`;
          }
        }).join('\n');

        Swal.fire({
          title: "Invalid Return Configuration",
          html: `
          <div style="text-align: left;">
            <p><strong>The following items have invalid return configurations:</strong></p>
            <div style="background: #fff1f0; padding: 10px; margin: 10px 0; border-radius: 4px;">
              ${errorDetails.replace(/\n/g, '<br>')}
            </div>
            <p style="color: #faad14;">
              <strong>${invalidSerialRows.some(item => item.serial_mode === "batch") ?
              'Batch items can only be returned completely. ' : ''}
              ${invalidSerialRows.some(item => item.serial_mode === "unit") ?
              'Unit items require the selected serial count to match the return quantity.' : ''}
            </strong>
          </p>
          </div>
        `,
          icon: "warning",
          confirmButtonText: "OK"
        });
        return;
      }
    }

    Swal.fire({
      title: "Saving Purchase Return...",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    // const invalidSerialRows =
    //   itemCart.filter(item => {

    //     if (
    //       !item.availableSerials ||
    //       item.availableSerials.length === 0
    //     ) {
    //       return false;
    //     }

    //     return (
    //       Number(item.return_qty || 0) !==
    //       (item.selectedSerials || []).length
    //     );
    //   });

    // const invalidSerialRows = itemCart.filter(item => {

    //   if (item.serial_mode === "batch") {

    //     const qty = Number(item.return_qty || 0);
    //     const availableQty = Number(item.available_qty || 0);

    //     // Not returning this batch -> no validation
    //     if (qty === 0) {
    //       return false;
    //     }

    //     // If returning, it must be the full batch
    //     return qty !== availableQty;
    //   }

    //   if (item.serial_mode === "unit") {

    //     return (
    //       Number(item.return_qty || 0) !==
    //       (item.selectedSerials || []).length
    //     );
    //   }

    //   return false;
    // });
    // console.log(invalidSerialRows, "invalidSerialRows");

    // if (invalidSerialRows.length > 0) {

    //   Swal.fire(
    //     "Invalid Return Quantity",
    //     "Batch items can only be returned completely. Unit items require the selected serial count to match the return quantity.",
    //     "warning"
    //   );

    //   return;
    // }

    dispatch(createPurchaseReturn(pur_r_id))
      .unwrap()
      .then((res) => {
        Swal.close();
        if (!res.error) {
          dispatch(setSupplier(null));
          dispatch(setInvoiceList([]));
          dispatch(setSelectedInvoice(null));

          Swal.fire({
            title: pur_r_id ? "Purchase Return Updated! Do you want to view voucher?" : "Purchase Return Created! Do you want to view voucher?",
            icon: "success",
            showCancelButton: true,
            confirmButtonText: "Yes, view voucher",
            cancelButtonText: "No, back",
          }).then((result) => {
            if (result.isConfirmed) {
              navigate(
                `/purchase/quick-purchase-return-voucher/${res.pur_r_id}`, { replace: true }
              );
            } else {
              dispatch(resetPurchaseReturn());
              window.location.reload();
              navigate("/purchase-return", { replace: true });
            }
          });
        } else {
          Swal.fire(res.message || "Something went wrong", "", "warning");
        }
      })
      .catch((error) => {
        console.log(error, "error1212");

        Swal.close();
        const message =
          error?.message ||
          error?.payload?.message ||
          error ||
          "Something went wrong while creating the purchase return.";

        Swal.fire({
          title: "Purchase Return Failed",
          html: String(message).replace(/\n/g, "<br>"),
          icon: "warning",
          confirmButtonText: "OK",
        });

        // Swal.fire("Network ERROR", "", "error");
      });
  };

  const handleUpdatedServices = (services, key) => {
    // setUpdatedServices(...services);
    setUpdatedServices((prev) => ({
      ...prev,
      [key]: services,
    }));
  };

  return (
    <div style={{ padding: 20 }}>
      <Row>
        <Col span={24}>
          <Flex justify="flex-end" gap={16} style={{ marginBottom: 16 }}>
            <Button onClick={() => navigate(-1)}>Back</Button>
            <Button
              onClick={() => {
                dispatch(resetPurchaseReturn());
                dispatch(fetchPurchaseReturnNumber());
              }}
            >
              Reset
            </Button>
            <Button type="primary" onClick={handleSave}>
              Save
            </Button>
          </Flex>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col span={24}>
          <CreatePurchaseReturnForm authInfo={authInfo} pur_r_id={pur_r_id} />
        </Col>
        <Col span={24}>
          <PurchaseReturnTable
            authInfo={authInfo}
            onUpdateServices={handleUpdatedServices}
          />
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Flex justify="flex-end" gap={16} style={{ marginBottom: 16 }}>
            <Button onClick={() => navigate(-1)}>Back</Button>
            <Button
              onClick={() => {
                dispatch(resetPurchaseReturn());
                dispatch(fetchPurchaseReturnNumber());
              }}
            >
              Reset
            </Button>
            <Button
              type="primary"
              onClick={handleSave}
              data-testid="final-save-btn"
            >
              Save
            </Button>
          </Flex>
        </Col>
      </Row>
    </div>
  );
};

export default PurchaseReturnEntry;
